import React, { useState } from "react";
import { doReportPractice } from "../../GestisciPraticheSlice";
import { useDispatch, useSelector } from "react-redux";
import CoreButtonHoverIcon from "../../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
// import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CoreModal from "../../../../../app/core/components/CoreModal/CoreModal";
import CreaPratichePage from "../../CreaPratichePage/CreaPratichePage";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { t } from "i18next";
// import CoreSpeedDial from "../../../../../app/core/components/CoreSpeedDial/CoreSpeedDial";
import { toast } from "react-toastify";

const GestisciPraticaButtonCockpit = ({ onRefetch }) => {
  const practiceManagement = useSelector(
    (state) => state.practiceManagementSlice
  );
  const [openModal, setOpenModal] = useState(false);
  const isSelectedPracticeEmpty =
    practiceManagement.selectedPracticesIds.length === 0;

  //HOOKS
  const dispatch = useDispatch();

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleDownload = () => {
    toast.info(t("HandleDownload"));
    dispatch(doReportPractice());
  };

  const handleDeletePractices = () => {
    // setOpenDeleteDialog(true);
    console.log("Delete:", practiceManagement.selectedPracticesIds);
  };

  const multiActions = [
    {
      icon: (
        <DeleteRoundedIcon
          className={
            isSelectedPracticeEmpty ? `fill-gray-200` : `fill-rose-600`
          }
        />
      ),
      name: t("Delete"),
      onClick: handleDeletePractices,
    },
    // {
    //   icon: (
    //     <DownloadRoundedIcon
    //       className={
    //         isSelectedPracticeEmpty ? `fill-gray-200` : `fill-darkgray `
    //       }
    //     />
    //   ),
    //   name: t("Delete"),
    //   onClick: handleDownload,
    // },
  ];

  return (
    <div className="flex w-full items-center">
      <CoreButtonHoverIcon
        onClick={onRefetch}
        className="text-blue-500 m-1 flex flex-row space-x-2 border"
        testo={t("Refresh")}
        icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
      />
      <CoreButtonHoverIcon
        onClick={handleOpenModal}
        className="text-blue-700 m-1"
        icon={<AddBoxRoundedIcon className={`fill-blue-700 `} />}
        testo={t("Practice")}
      />

      <CoreModal
        component={<CreaPratichePage closeModal={handleCloseModal} />}
        state={openModal}
        onClose={handleCloseModal}
        width={1000}
        maxHeight={800}
      />
      {/* <CoreSpeedDial
        actions={multiActions}
        selectedDoc={isSelectedPracticeEmpty}
      /> */}
    </div>
  );
};

export default GestisciPraticaButtonCockpit;
